__webpack_require__.p = "/oticas-vida/";